<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-10 18:20:34
 * @LastEditTime: 2021-03-04 15:47:48
-->
<template>
  <div class="addDevices">
    <!-- 设备列表选择（设备管理服务端的设备） -->
    <select-deviceList
      ref="selectDevices"
      :isChexkBox="false"
      :isRadio="true"
    ></select-deviceList>
    <div style="text-align: center; margin-top: 50px">
      <el-button size="mini" @click="preStep">{{
        $t("lang.FastAccess.previous")
      }}</el-button>
      <el-button size="mini" type="primary" @click="next">{{
        $t("lang.FastAccess.next")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import selectDeviceList from "../../components/selectDeviceList/index";
import { queryKeyword } from "@/api/devicelist";
import { addDevice } from "@/api/cloudMonitor/deviceList";
export default {
  components: {
    selectDeviceList,
  },
  props: ["projectGroupInfo"],
  data() {
    return {
      deviceList: [],
      deviceSelection: [],
      groupName: "",
    };
  },
  methods: {
    next() {
      // 返回的是数组
      this.deviceSelection = this.$refs.selectDevices.getSelectDevices();
      if (this.deviceSelection.length <= 0) {
        this.$message.warning(this.$t("lang.DateSelect.message2"));
      } else {
        //  let version = this.deviceSelection[0].deviceSoftwareVer.substring(1, 4)
        //  if (version < '2.3') {
        //    this.$message.warning('设备版本不支持，请检查！')
        //  }else
        if (this.deviceSelection[0].deviceIsconnected == 3) {
          let submitData = {
            deviceIds: [this.deviceSelection[0].deviceId],
            deviceGid: this.projectGroupInfo.id,
          };
          addDevice(submitData)
            .then((res) => {
              if (res.data.code === 0) {
                this.$emit("next");
              } else {
                this.$message.error(
                  this.$t("lang.FastAccess.Failedtoadddevice")
                );
              }
            })
            .catch(() => {
              this.$message.error(this.$t("lang.FastAccess.tryagain"));
            });
        } else {
          // 设备未连接提醒用户重新选择
          this.$message.warning(this.$t("lang.FastAccess.pleasechooseanother"));
        }
      }
    },
    preStep() {
      this.$emit("preStep");
    },
    getSelections() {
      return this.deviceSelection;
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
.devices-form {
  margin-top: 50px;
}
.addDevices {
  padding-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
